import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FaTimes } from "react-icons/fa";
import { rejectPurchaseRequest, getPurchaseRequest } from "redux/erp/purchaseRequestSlice";
import { Modal, Button, FormInput } from 'components/common';

const RejectForm = ({ show, onHide, purchaseRequest }) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async () => {
    if (!comment.trim()) { toast.warning("Please enter a rejection reason."); return; }
    setBusy(true);
    try {
      await dispatch(rejectPurchaseRequest({ id: purchaseRequest.id, comment })).unwrap();
      await dispatch(getPurchaseRequest(purchaseRequest.id));
      toast.success("Purchase request rejected.");
      onHide();
    } catch (e) { toast.error(e?.error || e?.message || "Rejection failed."); }
    finally { setBusy(false); }
  };

  return (
    <Modal show={show} onHide={onHide} title={`Reject ${purchaseRequest?.code}`} size="md"
      footer={<>
        <Button variant="secondary" size="sm" disabled={busy} onClick={onHide}>Cancel</Button>
        <Button variant="danger" size="sm" leftIcon={FaTimes} disabled={busy} onClick={onSubmit}>Reject</Button>
      </>}>
      <div className="geist-scope">
        <FormInput label="Rejection reason" required type="textarea" rows={3} value={comment} onChange={(e) => setComment(e.target.value)} />
      </div>
    </Modal>
  );
};

RejectForm.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  purchaseRequest: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    code: PropTypes.string,
  }),
};

export default RejectForm;
